import React, { useState } from "react";
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { Box, Typography, CircularProgress, Collapse, List, ListItemButton } from '@mui/material';
import { ccyFormat } from '../helpers/helper';

const InvestmentData = ({ investment, investors, loading, tittle }) => {
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  return (<>
    <List sx={{width: '100%' ,padding: '0', margin:'0'}}>
      <ListItemButton onClick={handleClick} sx={{justifyContent: 'space-between', padding: '0'}}>
        {/* <ListItemIcon>
          <MoveToInbox />
        </ListItemIcon> */}
        <Box display='flex' flexDirection='row' width='100%'>
          <Typography display='flex' flexDirection='row' justifyContent='space-between' variant='button' width='100%'>
            <Box display='flex' component='span'>{tittle}</Box>
            {loading ? <CircularProgress size="1rem"/> :
            <Box display='flex' component='span'>{`$${ccyFormat(investment)}`}</Box>}
          </Typography>
          {/* <ListItemText primary="Inbox" /> */}
          {open ? <ExpandLess /> : <ExpandMore />}
        </Box>
      </ListItemButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List sx={{width: '100%' ,padding: '0', margin:'0'}}>
          {investors && Object.entries(investors).map(([investor, amount]) => 
            <ListItemButton sx={{ paddingY: 0, justifyContent: 'flex-end', paddingRight: 0 }}>
              {/* <ListItemIcon>
                <StarBorder />
              </ListItemIcon>
              <ListItemText primary="Starred" /> */}
              <Box display='flex' flexDirection='row' width='100%'>
                <Typography display='flex' flexDirection='row' justifyContent='space-between' variant='button' width='100%'>
                  <Box display='flex' component='span'>{`${investor}:`}</Box>
                  {loading ? <CircularProgress size="1rem"/> :
                  <Box display='flex' component='span'>{`$${ccyFormat(amount)}`}</Box>}
                </Typography>
              </Box>
            </ListItemButton>)
          }
        </List>
      </Collapse>
    </List>
  </>)
}

export default InvestmentData;